import { render, staticRenderFns } from "./imClient.vue?vue&type=template&id=1a21508c"
import script from "./imClient.vue?vue&type=script&lang=js"
export * from "./imClient.vue?vue&type=script&lang=js"
import style0 from "./imClient.vue?vue&type=style&index=0&id=1a21508c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports